import React, { Component, Suspense } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { CSpinner } from '@coreui/react-pro'
import './scss/style.scss'
import ProtectedRoute from './routing/ProtectedRoute'
import Page404 from './views/pages/page404/Page404'

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

const Login = React.lazy(() => import('./views/pages/login/Login'))
const Http404 = React.lazy(() => import('./views/pages/page404/Page404'))

class App extends Component {
  render() {
    return (
      <HashRouter>
        <Suspense fallback={<CSpinner color="primary" />}>
          <Routes>
            <Route element={<ProtectedRoute />}>
              <Route path="*" name="Главная" element={<DefaultLayout />} />
            </Route>
            <Route exact path="/login" name="Login Page" element={<Login />} />
            <Route exact path="/404" name="Not Found" element={<Page404 />} />
          </Routes>
        </Suspense>
      </HashRouter>
    )
  }
}

export default App
